import { columnHelper } from './helper';

export const message = columnHelper.accessor('message', {
  header: 'Message',
});
